<template>
  <div>
    <div class="reason" v-if="type == 1 && list.reason">
      未通过原因：{{ list.reason }}
    </div>
    <van-cell-group class="body kuang">
      <!-- <van-cell 
        v-if="list.schoolOutAreaTxt" 
        title="校外少工委所在地" 
        :value="list.schoolOutAreaTxt" 
      /> -->
      <van-cell 
        v-if="list.organizationTypeTxt" 
        title="组织类型" 
        :value="list.organizationTypeTxt" 
      />
      <van-cell 
        v-if="list.schoolOutSgwName" 
        title="校外少工委组织名称" 
        :value="list.schoolOutSgwName" 
      />
      <van-cell 
        v-if="list.foundTime" 
        title="成立时间" 
        :value="format(list.foundTime, 6)" 
      />
      <van-cell 
        v-if="list.sgwZhuRenName" 
        title="少工委主任姓名" 
        :value="list.sgwZhuRenName"
      />
      <van-cell 
        v-if="list.organization" 
        title="所在单位" 
        :value="list.organization"
      />
      <van-cell 
        v-if="list.sgwZhuRenMajorTxt" 
        title="少工委主任职务" 
        :value="list.sgwZhuRenMajorTxt"
      />
      <van-cell 
        v-if="list.phone" 
        title="手机号" 
        :value="list.phone"
      />
    </van-cell-group>
  </div>
</template>

<script setup>
  import { format } from "@/common/js/utils";
  import { defineProps } from 'vue';
  
  // 直接使用 props，不需要定义在 setup 的返回对象中
  const props = defineProps({
    list: Object,
    type: Number,
  });
  console.log("form10---EditList", props.list);
</script>

<style lang="less" scoped>
@import "@/common/style/mixin";
.u_sh li {
  display: list-item;
  height: 1.5rem;
}
.u_sh .fl {
  width: 90%;
}
.reason {
  font-size: 0.397rem;
  line-height: 1.4;
  color: #fd3535;
  vertical-align: middle;
  margin: 0.4rem;
}
.custom-cell-title {
  font-weight: bold;
  font-size: 16px;
}
</style>
